import { classNames, tw } from '@panwds/tailwindcss';
export const getCursorClass = ({ disabled = false, readOnly = false }) => {
    if (disabled || readOnly) {
        return tw `twds-cursor-not-allowed focus:twds-cursor-not-allowed hover:twds-cursor-not-allowed`;
    }
    return tw `twds-cursor-pointer`;
};
export const getBorderClass = ({ disabled = false, isError = false, readOnly = false }) => {
    const borderBaseClassDef = tw `twds-border-none`;
    if (isError && !(disabled || readOnly)) {
        return tw `twds-border-red-500 dark:twds-border-red-500`;
    }
    return borderBaseClassDef;
};
export const getRingClass = ({ disabled = false, isActive = false, isPressed = false, isHovered = false, readOnly = false }) => {
    if (disabled || readOnly) {
        return tw `hover:twds-ring-0`;
    }
    if (isPressed) {
        return tw `focus:twds-ring-blue-200 dark:focus:twds-ring-gray-700 focus:twds-ring-2 dark:focus:twds-ring-offset-black`;
    }
    if (isHovered) {
        return tw `hover:twds-ring hover:twds-ring-offset-0 hover:twds-ring-blue-200 dark:hover:twds-ring-gray-700  dark:focus:twds-ring-offset-black `;
    }
    if (isActive) {
        return tw `focus:twds-ring-blue-500 dark:focus:twds-ring-blue-500 focus:twds-ring-2 dark:focus:twds-ring-offset-black`;
    }
    return '';
};
export const getBackgroundClass = () => {
    return tw `
		dark:checked:twds-bg-black checked:twds-bg-white checked:twds-bg-opacity-80 dark:checked:twds-bg-opacity-[0.16]
		dark:checked:hover:twds-bg-black checked:hover:twds-bg-white checked:hover:twds-bg-opacity-80 dark:checked:hover:twds-bg-opacity-[0.16]
		dark:checked:focus:twds-bg-black checked:focus:twds-bg-white checked:focus:twds-bg-opacity-80 dark:checked:focus:twds-bg-opacity-[0.16]
		dark:hover:twds-bg-black hover:twds-bg-white hover:twds-bg-opacity-80 dark:hover:twds-bg-opacity-[0.16]
		dark:focus:twds-bg-black focus:twds-bg-white focus:twds-bg-opacity-80 dark:focus:twds-bg-opacity-[0.16]
		twds-bg-white dark:twds-bg-black twds-bg-opacity-80 dark:twds-bg-opacity-[0.16]
		`;
};
export function getLabelTextColorClass({ disabled = false }) {
    if (disabled) {
        return tw `twds-text-disabled dark:twds-text-secondary`;
    }
    return tw `twds-text-primary dark:twds-text-gray-100`;
}
export function getLabelCursorClass({ disabled = false, readOnly = false }) {
    if (disabled || readOnly) {
        return tw `twds-cursor-not-allowed`;
    }
    return tw `twds-cursor-pointer`;
}
export function getDisabledStyles({ readOnly = false, isChecked = false }) {
    if (!readOnly)
        return '';
    return classNames('twds-cursor-not-allowed twds-pointer-events-none', isChecked
        ? '!twds-bg-radio-disabled-checked-svg !dark:twds-bg-radio-disabled-checked-svg'
        : '!twds-bg-radio-disabled-svg !dark:twds-bg-radio-disabled-svg');
}
//# sourceMappingURL=radio.logic.js.map